import React from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { ArrowLeftIcon } from '@heroicons/react/24/outline';

const ComingSoonBanner: React.FC = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  return (
    <>
      {/* Overlay Background */}
      <div className="fixed inset-0 bg-black bg-opacity-50 backdrop-blur-sm z-40" />
      
      {/* Diagonal Banner */}
      <div className="fixed inset-0 z-50 flex items-center justify-center">
        <div 
          className="transform rotate-12 bg-gradient-to-r from-red-600 via-orange-500 to-yellow-400 text-white px-16 py-8 shadow-2xl border-4 border-yellow-300"
          style={{
            background: 'linear-gradient(135deg, #dc2626 0%, #ea580c 25%, #f59e0b 50%, #eab308 75%, #facc15 100%)',
            boxShadow: '0 25px 50px -12px rgba(0, 0, 0, 0.5), inset 0 1px 0 rgba(255, 255, 255, 0.2)',
            borderStyle: 'dashed',
            borderWidth: '3px',
            borderColor: '#fef3c7',
          }}
        >
          <div className="text-center transform -rotate-3">
            <div className="flex items-center justify-center mb-6">
              <div className="relative">
                <svg 
                  className="w-16 h-16 mr-4 animate-pulse drop-shadow-lg" 
                  fill="currentColor" 
                  viewBox="0 0 20 20"
                >
                  <path 
                    fillRule="evenodd" 
                    d="M10 18a8 8 0 100-16 8 8 0 000 16zm1-12a1 1 0 10-2 0v4a1 1 0 00.293.707l2.828 2.829a1 1 0 101.415-1.415L11 9.586V6z" 
                    clipRule="evenodd" 
                  />
                </svg>
                <div className="absolute -top-2 -right-2 w-6 h-6 bg-yellow-300 rounded-full animate-ping opacity-75"></div>
              </div>
              <h1 className="text-5xl font-black tracking-wider drop-shadow-lg">
                {t('comingSoon.title')}
              </h1>
            </div>
            
            <div className="space-y-4 max-w-2xl mx-auto">
              <p className="text-2xl font-bold drop-shadow-md">
                {t('comingSoon.message')}
              </p>
              <p className="text-xl opacity-95 font-medium">
                {t('comingSoon.subscribe')}
              </p>
              
              <div className="mt-8 inline-flex items-center px-8 py-4 bg-white bg-opacity-25 rounded-full backdrop-blur-sm border-2 border-white border-opacity-50">
                <span className="animate-bounce mr-3 text-2xl">🚀</span>
                <span className="text-lg font-bold">
                  {t('comingSoon.workingHard')}
                </span>
              </div>
              
              {/* Back Button */}
              <div className="mt-8">
                <button
                  onClick={() => navigate(-1)}
                  className="inline-flex items-center px-6 py-3 bg-white bg-opacity-90 hover:bg-opacity-100 text-gray-900 rounded-full font-semibold transition-all transform hover:scale-105 shadow-lg hover:shadow-xl pointer-events-auto"
                >
                  <ArrowLeftIcon className="h-5 w-5 mr-2" />
                  {t('common.back', 'Go Back')}
                </button>
              </div>
            </div>

            {/* Decorative elements */}
            <div className="absolute -top-4 -left-4 w-8 h-8 bg-yellow-300 rounded-full opacity-80 animate-pulse"></div>
            <div className="absolute -bottom-4 -right-4 w-6 h-6 bg-red-300 rounded-full opacity-80 animate-pulse delay-300"></div>
            <div className="absolute top-1/2 -left-6 w-4 h-4 bg-orange-300 rounded-full opacity-80 animate-pulse delay-150"></div>
            <div className="absolute top-1/4 -right-6 w-5 h-5 bg-yellow-200 rounded-full opacity-80 animate-pulse delay-500"></div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ComingSoonBanner;